// Supabase client configuratie
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// In een productieomgeving zouden deze waarden uit environment variabelen komen:
// const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
// const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;
const SUPABASE_URL = "https://lozejxkhsvwkksgzhrfd.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxvemVqeGtoc3Z3a2tzZ3pocmZkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjY0OTY4OTcsImV4cCI6MjA4MjA3Mjg5N30.GvcNibeMI-dF1dq4s4mq5Ap9Edspot9s5mdjUEWfZ0M";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY);